import { assemblyKindToLabel } from '@domainConstants'
import numeral from 'numeral'

export const weightFormatter = (weight: number) => {
  const formatter = '0[.][00]'
  return `${numeral(weight).format(formatter)}`
}

export const assemblyKindFormatter = (kind: string) => {
  return assemblyKindToLabel[kind as AssemblyKind]
}
